import { FC } from 'react'

import { Card, FeedItem } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedItemProps } from './types'

export const ActivityFeedItemCreateShipment: FC<ActivityFeedItemProps> = ({ item, status }) => {
  const { translate, translateDate } = useLocalisation()

  return (
    <FeedItem
      type="positive"
      name={item.activity.actor.fullName || 'Service'}
      action={translate('feed.list.CreateShipment.action')}
      date={translateDate('feed_date', item.activity.createdAt)}
      suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
      status={status}
    >
      {item.activity.customField.date ? (
        <Card>{translateDate('feed_date', item.activity.customField.date.value)}</Card>
      ) : null}
      <a id={`feed-activity-${item.id}`} />
    </FeedItem>
  )
}
